import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { CalrunidsComponent } from './calrunids/calrunids.component';
import { AddCalcRunComponent } from './add-calc-run/add-calc-run.component';
import { ManagecalcComponent } from './managecalc/managecalc.component';
import { UserControlComponent } from './user-control/user-control.component';
import { CalcstatusComponent } from './calcstatus/calcstatus.component';

const routes: Routes = [
  {path:'manage-calc', component:ManagecalcComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  {path:'manage-calrunid', component:CalrunidsComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  {path:'user-control', component:UserControlComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  {path:'add-calcrun', component:AddCalcRunComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  {path:'calc-status', component:CalcstatusComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnlinecalcRoutingModule { }
